/**
 * SiliDog cart sync — 2026-09-17
 *
 * Problem this fixes (P0, found 2026-09-17):
 *   Monster Upsells (and Navidium) add to / change the cart with their own
 *   fetch/XHR calls. Horizon's header bubble and cart drawer only update when
 *   they receive `shopify:cart:lines-update`, which those apps never dispatch.
 *   Result: a shopper adds a tag, the Monster drawer shows it, they close it,
 *   click the header cart — and Horizon says "Your cart is empty" with a 0
 *   badge, while /cart.js genuinely holds the item. Reproduced end-to-end.
 *
 * Fix: watch for any cart-mutating request we did not make ourselves, then
 *   re-read /cart.js and re-render the bubble + drawer section. Deliberately
 *   app-agnostic — it keys off the cart URLs, not off any app's internals, so
 *   it keeps working if an app updates or is swapped out.
 */
(function () {
  if (window.__sdCartSync) return;
  window.__sdCartSync = true;

  var MUTATES = /\/cart\/(add|change|update|clear)(\.js|\.json)?$/i;
  var DRAWER_ID = 'shopify-section-cart-drawer-section';
  var nativeFetch = window.fetch.bind(window);
  var pending = null;
  var internal = false; // guards our own requests so we never loop

  function isMutator(url) {
    try {
      return MUTATES.test(String(url).split('?')[0]);
    } catch (e) {
      return false;
    }
  }

  function schedule() {
    if (internal) return;
    clearTimeout(pending);
    // let the app finish its own DOM work first
    pending = setTimeout(sync, 150);
  }

  function sync() {
    internal = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        updateBubble(cart.item_count);
        return refreshDrawer();
      })
      .catch(function () { /* never let a sync failure surface to the shopper */ })
      .then(function () { internal = false; });
  }

  function updateBubble(count) {
    // The count span ships with a `hidden` class and Horizon's own cart-icon.js
    // is what removes it. We bypass that code path, so we must toggle it too —
    // otherwise the black bubble renders with no number in it (seen live
    // 2026-09-17: bag icon showed a solid dark dot and no quantity).
    var countEl = document.querySelector('[ref=cartBubbleCount], .cart-bubble__text-count, .cart-bubble__count');
    if (countEl) {
      countEl.textContent = count < 100 ? String(count) : '';
      countEl.classList.toggle('hidden', count === 0);
    }
    var bubble = document.querySelector('.cart-bubble');
    if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
  }

  function refreshDrawer() {
    var live = document.getElementById(DRAWER_ID);
    if (!live) return null;
    return nativeFetch('/?section_id=cart-drawer-section', {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(DRAWER_ID) || doc.body.firstElementChild;
        if (!fresh) return;

        // If the drawer is open we must NOT replace the <dialog> itself —
        // swapping it closes the drawer under the shopper's hands. Replace only
        // the inner panel, which is what actually carries the line items and
        // the cart-drawer--empty state.
        var liveInner = live.querySelector('.cart-drawer__inner');
        var freshInner = fresh.querySelector('.cart-drawer__inner');
        if (liveInner && freshInner) {
          liveInner.replaceWith(freshInner);
        } else {
          live.innerHTML = fresh.innerHTML;
        }
      });
  }

  // --- fetch
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = nativeFetch.apply(null, arguments);
    if (isMutator(url)) {
      p.then(function (res) { if (res && res.ok) schedule(); }).catch(function () {});
    }
    return p;
  };

  // --- XHR (some app bundles still use it)
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__sdUrl = url;
    return open.apply(this, arguments);
  };
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    xhr.addEventListener('load', function () {
      if (xhr.status >= 200 && xhr.status < 300 && isMutator(xhr.__sdUrl)) schedule();
    });
    return send.apply(this, arguments);
  };

  // Belt and braces: coming back via bfcache, or returning to the tab, both
  // leave the header stale if an app mutated the cart meanwhile.
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') schedule();
  });
})();
